<template>
  <div class="point">
    <el-tabs type="border-card" @edit="handleTabsEdit" v-model="activetab">
      <el-tab-pane
        :label="item.name"
        :name="item.title"
        v-for="(item, index) in tabDatas"
        :key="index"
        :closable="item.title !== 'admin'"
        :ref="item.title"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="content" v-show="activetab == 'admin'">
      <div class="header">
        <el-button
          type="primary"
          size="mini"
          @click="addData()"
          style="margin-top: 15px"
          >新增</el-button
        >
        <div class="searchinput">
          <span>单位名称：</span
          ><el-input v-model="departmentsearch" size="mini"></el-input>
        </div>
        <div class="searchinput">
          <span>等级：</span
          ><el-input v-model="levelsearch" size="mini"></el-input>
        </div>
        <el-button
          type="primary"
          size="mini"
          @click="search()"
          style="margin-top: 15px; margin-left: 20px"
          >搜索</el-button
        >
      </div>
      <el-table
        stripe
        size="small"
        :header-cell-style="{
          background: '#eef1f6',
          padding: '1px 0px',
          color: 'black',
        }"
        style="width: 100%; font-size: 12px; color: black"
        ref="multipleTable5"
        :data="tableData"
        v-loading="loading"
        element-loading-text="拼命加载中"
        tooltip-effect="dark"
        height="calc(100% - 100px)"
      >
        <el-table-column
          v-for="(item, index) in currentcloumn"
          :key="index"
          :prop="item.name"
          :label="item.title"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="item.name == 'department'">
              <el-link style="font-size: 12px; color: black">
                <span @click="editData(scope.row)">{{
                  scope.row[item.name]
                }}</span>
              </el-link>
            </div>
            <div v-else-if="item.name == 'type'">
              {{
                types.filter((v) => v.row_id == scope.row[item.name])
                  ? types.filter((v) => v.row_id == scope.row[item.name])[0]
                      .name
                  : ""
              }}
            </div>
            <div v-else>
              {{ scope.row[item.name] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div style="display: flex; height: 23px; align-items: center">
              <el-button
                @click="editData(scope.row)"
                type="text"
                size="small"
                style="margin-right: 10px !important"
                >编辑</el-button
              >
              <el-popconfirm
                style="margin-right: 10px !important"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon="el-icon-info"
                icon-color="red"
                @confirm="del(scope.row)"
                title="确定删除吗？"
              >
                <el-button slot="reference" type="text" size="small"
                  >删除</el-button
                >
              </el-popconfirm>
              <el-button @click="detailData(scope.row)" type="text" size="small"
                >明细</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagi-nation
        :Count="Count"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
        ref="pagination"
      ></pagi-nation>
    </div>
    <div class="content" v-if="activetab == 'add'">
      <div class="formdata">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="100px"
          style="width: 30%"
          size="mini"
        >
          <el-form-item label="单位名称：" prop="department">
            <el-input v-model="form.department" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="会员等级：" prop="level">
            <el-select v-model="form.level" placeholder="请选择">
              <el-option
                v-for="item in types"
                :key="item.row_id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总名额：" prop="toatal">
            <el-input v-model="form.toatal" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="已用名额：" prop="used">
            <el-input v-model="form.used" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="到期时间：" prop="end_data">
            <el-date-picker
              v-model="form.end_data"
              type="date"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发布时间：" prop="publish_date">
            <el-date-picker
              v-model="form.publish_date"
              type="date"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button
            type="primary"
            size="mini"
            @click="add()"
            style="margin-right: 20px !important"
            >保存</el-button
          >
          <el-button type="primary" size="mini" @click="close()"
            >取消</el-button
          >
        </div>
      </div>
    </div>
    <div class="content" v-if="activetab == 'edit'">
      <div class="formdata">
        <el-form
          ref="form2"
          :rules="rules"
          :model="form"
          label-width="100px"
          style="width: 30%"
          size="mini"
        >
          <el-form-item label="单位名称：" prop="department">
            <el-input v-model="form.department" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="会员等级：" prop="level">
            <el-select v-model="form.level" placeholder="请选择">
              <el-option
                v-for="item in types"
                :key="item.row_id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总名额：" prop="toatal">
            <el-input v-model="form.toatal" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="已用名额：" prop="used">
            <el-input v-model="form.used" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="到期时间：" prop="end_data">
            <el-date-picker
              v-model="form.end_data"
              type="date"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发布时间：" prop="publish_date">
            <el-date-picker
              v-model="form.publish_date"
              type="date"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button
            type="primary"
            size="mini"
            @click="edit()"
            style="margin-right: 20px !important"
            >保存</el-button
          >
          <el-button type="primary" size="mini" @click="close()"
            >取消</el-button
          >
        </div>
      </div>
    </div>
    <div class="content" v-if="activetab == 'detail'">
      <div class="header">
        <el-button
          type="primary"
          size="mini"
          @click="close()"
          style="margin-top: 15px"
          >返回</el-button
        >
      </div>
      <el-table
        stripe
        size="small"
        :header-cell-style="{
          background: '#eef1f6',
          padding: '1px 0px',
          color: 'black',
        }"
        style="width: 100%; font-size: 12px; color: black"
        ref="multipleTable5"
        :data="detailtableData"
        v-loading="loading"
        element-loading-text="拼命加载中"
        tooltip-effect="dark"
        height="calc(100% - 50px)"
      >
        <el-table-column
          v-for="(item, index) in detailcloumn"
          :key="index"
          :prop="item.name"
          :label="item.title"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="item.name == 'title'">
              <el-link style="font-size: 12px; color: black">
                <span @click="editData(scope.row)">{{
                  scope.row[item.name]
                }}</span>
              </el-link>
            </div>
            <div v-else-if="item.name == 'type'">
              {{
                types.filter((v) => v.row_id == scope.row[item.name])
                  ? types.filter((v) => v.row_id == scope.row[item.name])[0]
                      .name
                  : ""
              }}
            </div>
            <div v-else>
              {{ scope.row[item.name] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import pagiNation from "@/components/pagiNation";
export default {
  data() {
    return {
      property: "value",
      tableData: [],
      currentcloumn: [
        {
          title: "单位名称",
          name: "department",
        },
        {
          title: "会员等级",
          name: "level",
        },
        {
          title: "总名额",
          name: "toatal",
        },
        {
          title: "已用名额",
          name: "used",
        },
        {
          title: "到期时间",
          name: "end_data",
        },
        {
          title: "发布时间",
          name: "publish_date",
        },
      ],
      detailcloumn: [
        {
          title: "id",
          name: "member_id",
        },
        {
          title: "姓名",
          name: "name",
        },
        {
          title: "部门",
          name: "department",
        },
        {
          title: "身份证",
          name: "idcard",
        },
        {
          title: "会员id",
          name: "vip_id",
        },
        {
          title: "兑换日期",
          name: "publish_date",
        },
      ],
      Count: 0,
      PageSize: 15,
      currentPage: 1,
      loading: false,
      tabDatas: [
        {
          name: "会员管理",
          title: "admin",
        },
      ],
      activetab: "admin",
      form: {},
      types: [
        {
          row_id: "0",
          name: "普通会员单位",
        },
        {
          row_id: "1",
          name: "理事单位",
        },
        {
          row_id: "2",
          name: "常务理事单位",
        },
        {
          row_id: "3",
          name: "副会长单位",
        },
      ],
      rules: {
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
      },
      detailtableData: [],
      departmentsearch: "",
      levelsearch: "",
    };
  },
  components: {
    pagiNation,
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    detailData(row) {
      let item = {
        name: row.department + "-明细",
        title: "detail",
      };
      let list = this.tabDatas.filter(
        (v) => v.title == "edit" || v.title == "add" || v.title == "detail"
      );

      if (list.length == 0) {
        this.tabDatas.push(item);
      } else {
        this.tabDatas = this.tabDatas.filter(
          (v) => v.title !== "edit" && v.title !== "add" && v.title == "detail"
        );
        this.tabDatas.push(item);
      }
      this.activetab = "detail";
      let params = {
        vip_id: row.row_id,
      };
      this.$http.get(this.$Api.getVipuselog, { params }).then((res) => {
        this.detailtableData = res.data.datalist;
      });
    },
    del(form) {
      console.log("form :>> ", form);
      let params = {
        dataListId: form.row_id,
      };
      this.$http.get(this.$Api.recycleVip, { params }).then((res) => {
        if (res.data.errcode == "0") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getTableData();
        } else {
          this.$message.error({
            message: "删除失败",
          });
        }
      });
    },
    edit() {
      this.$refs["form2"].validate((valid) => {
        if (valid) {
          let params = { data: this.form, dataId: this.form.row_id };
          console.log("params :>> ", params);
          this.$http.get(this.$Api.modifyVip, { params }).then((res) => {
            if (res.data.errcode == "0") {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.tabDatas = this.tabDatas.filter(
                (v) => v.title !== this.activetab
              );
              this.activetab = "admin";
              this.getTableData();
            } else {
              this.$message.error({
                message: "修改失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    editData(form) {
      this.form = form;
      let item = {
        name: form.department + "-编辑",
        title: "edit",
      };
      let list = this.tabDatas.filter(
        (v) => v.title == "edit" || v.title == "add" || v.title == "detail"
      );

      if (list.length == 0) {
        this.tabDatas.push(item);
      } else {
        this.tabDatas = this.tabDatas.filter(
          (v) => v.title !== "edit" && v.title !== "add" && v.title == "detail"
        );
        this.tabDatas.push(item);
      }
      this.activetab = "edit";
    },
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = { data: this.form };
          this.$http.get(this.$Api.addVip, { params }).then((res) => {
            if (res.data.errcode == "0") {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.tabDatas = this.tabDatas.filter(
                (v) => v.title !== this.activetab
              );
              this.activetab = "admin";
              this.getTableData();
            } else {
              this.$message.error({
                message: "新增失败",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    close() {
      this.tabDatas = this.tabDatas.filter((v) => v.title !== this.activetab);
      this.activetab = "admin";
    },
    handleTabsEdit(a, b) {
      this.tabDatas = this.tabDatas.filter((v) => v.title !== a);
      this.activetab = "admin";
    },
    addData() {
      this.form = {};
      let item = {
        name: "新增",
        title: "add",
      };
      let list = this.tabDatas.filter(
        (v) => v.title == "add" || v.title == "edit" || v.title == "detail"
      );

      if (list.length == 0) {
        this.tabDatas.push(item);
      } else {
        this.tabDatas = this.tabDatas.filter(
          (v) => v.title !== "edit" && v.title !== "add" && v.title == "detail"
        );
        this.tabDatas.push(item);
      }
      this.activetab = "add";
    },
    search() {
      this.currentPage = 1;
      this.$refs.pagination.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      let params = {
        pageNo: this.currentPage,
        pageNum: this.PageSize,
        department: this.departmentsearch,
        level: this.levelsearch,
      };
      this.$http({
        url: this.$Api.getVip,
        methods: "GET",
        params,
      })
        .then((result) => {
          this.loading = false;
          this.Count = result.data.total;
          this.tableData = result.data.datalist;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleSizeChange(e) {
      console.log("分页器数值改变", e);
      this.PageSize = e;
      this.getTableData();
    },
    onCurrentChange(e) {
      console.log("当前页数值变化", e);
      this.currentPage = e;
      this.getTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 50px;
  background-color: #fff;
  .searchinput {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-left: 20px;
    span{
              width: 60px;
    }
    &:nth-of-type(1) {
      span {
          width: 100px;
      }
    }
  }
}
.content {
  background-color: #fff;
  width: 100%;
  height: calc(100vh - 80px);
  .formdata {
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
  }
  .buttons {
    display: flex;
    padding-bottom: 40px;
    padding-left: 100px;
  }
}
/deep/.el-table {
  padding: 0 20px;
}
</style>